import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { colors } from "../../../../ui/colors";
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left";
import { Layout } from "../../../../ui/layout";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { ErrorPopup } from "../../../../ui/organisms/errorPopup";
import { MenuItems } from "../../../../ui/organisms/navbar/dto";
import { RightBar } from "../../../../ui/organisms/rightBar";
import { SuccessPopup } from "../../../../ui/organisms/successPopup";
import { CustomerInfoDTO } from "../dataService/dto";
import { EntryProtocolValidation, GetEntryProtocolById, resetEntryProtocolCreationStatus, resetEntryProtocols } from "../slice";
import { NewEntryLeft } from "./newEntryLeft";
import { NewEntryRight } from "./newEntryRight";

interface ProtocolData {
    protocol: string
    sender: string
    region: string
    object: string
    operator: CustomerInfoDTO[]
}

export function AddEntryProtocol() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)

    useEffect(() => {
        if (entryProtocolState.entryProtocolCreationStatus === 'successfully' &&
            entryProtocolState.entryProtocolCreationResponse !== undefined
        ) {
            dispatch(GetEntryProtocolById(entryProtocolState.entryProtocolCreationResponse))
        }
    }, [entryProtocolState.entryProtocolCreationStatus])

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Gestione Protocollo', 'Entrata', 'Inserimento']}
            noPaddingLat
            headerLabel="Nuovo Protocollo Entrata"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/entryProtocol')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end gap-2">
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Salva protocollo'
                        onClick={() => dispatch(EntryProtocolValidation(entryProtocolState.entryProtocolCreationRequest))}
                        disabled={
                            entryProtocolState.entryProtocolCreationStatus === 'loading' ||
                            !entryProtocolState.entryProtocolCreationRequest.headQuarter ||
                            !entryProtocolState.entryProtocolCreationRequest.protocolDate ||
                            !entryProtocolState.entryProtocolCreationRequest.region ||
                            !entryProtocolState.entryProtocolCreationRequest.sender ||
                            !entryProtocolState.entryProtocolCreationRequest.entryObjectId ||
                            !entryProtocolState.entryProtocolCreationRequest.totalPage ||
                            !entryProtocolState.entryProtocolCreationRequest.entryChannel ||
                            !entryProtocolState.entryProtocolCreationRequest.send ||
                            entryProtocolState.entryProtocolCreationRequest.destinationOffice.length === 0
                        }
                    />
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Nuovo Protocollo Entrata"
                        color={"gray"}
                        onClick={() => {
                            dispatch(resetEntryProtocols())
                            window.location.reload();
                        }}
                    />
                </div>
            }
        >
            <div className="w-full flex-row" style={{ display: 'flex', height: '100%' }}>
                <div className="w-[70%] flex flex-col gap-[16px] filter bg-brandPrimary-200" style={{ padding: '24px 24px 24px 24px', borderTopRightRadius: '20px' }}>
                    <SuccessPopup
                        message="Dati salvati correttamente."
                        active={entryProtocolState.entryProtocolCreationStatus === 'successfully'}
                        onClose={() => dispatch(resetEntryProtocolCreationStatus())}
                    />
                    <ErrorPopup
                        message={"Errore durante il salvataggio dei dati."}
                        active={entryProtocolState.entryProtocolCreationStatus === 'failed'}
                        onClose={() => dispatch(resetEntryProtocolCreationStatus())}
                    />
                    <NewEntryLeft />
                </div>
                <div className="w-[30%]">
                    <RightBar disabled={!entryProtocolState.fromCreationToUpdate}>
                        <NewEntryRight />
                    </RightBar>
                </div>
            </div>
        </Layout>
    )
}